import React, { useMemo, useState } from 'react';
import { chainEvent } from 'utils/react';
import type { Props } from './Input';
import Input from './Input';

/** Uses state of the art trickery to avoid Google Chrome autofill */
const InputWithAutoFillBlocking = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  // Chrome engineers think that autofill is the greatest shit ever,
  // so we need to do more than signal that we don't want autofill.
  // This method sets the readonly attribute on the input until it's focused.
  // From https://stackoverflow.com/a/26931180
  const [readOnly, setReadOnly] = useState(true);
  const handleFocus = useMemo(
    () => chainEvent(() => setReadOnly(false), props.onFocus),
    [props.onFocus]
  );
  const handleBlur = useMemo(
    () => chainEvent(() => setReadOnly(true), props.onBlur),
    [props.onBlur]
  );

  return (
    <Input
      ref={ref}
      {...props}
      autoComplete="off"
      readOnly={readOnly || props.readOnly}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
});

InputWithAutoFillBlocking.displayName = 'InputWithAutoFillBlocking';

export default InputWithAutoFillBlocking;
